<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <div v-show="Isblur" class="splash"></div>

    <sidebar></sidebar>
    <div class="card-panel-main col-lg-9 mb-5 p-2" style="transform: translateX(-19vw)">
      <div class="d-flex justify-content-between" style="margin: 2vw 0;">
        <h5 style="font-size: 1.3vw !important; margin-right: 2vw;">
          مدیریت مستندات فرآیندی
        </h5>
        <div class="changes">
          <router-link to="/Process/documentation/management">جستجوی سریع</router-link>
          <p href="">نمایش پوشه ای</p>
        </div>
      </div>
      <div class="w-100 p-1">
        <div style="background-color: #eee;" class="w-100 min-vh-100 border-2 p-3   "
             @contextmenu.prevent="rightContainerMethod">
          <center class="w-100">
            <div class="d-flex justify-content-center " style="transform: translateY(-1vw)">
              <div class="d-flex bg-white justify-content-center"
                   style="width: max-content; padding: 0 1vw; border-radius: 1vw; height: 2vw; ">
                <router-link style="display:block;" to="/Process/documentation/management/FolderMode"
                             class="text-decoration-none text-black">
                </router-link>
                <p v-if="cat.length">&nbsp; / </p>
                <p @click.prevent="nextPage(cat[0].id)" class="text-decoration-none text-black"  v-if="cat.length">&nbsp; {{ cat[0].title }} </p>
                <p v-if="parent.length">&nbsp; / </p>
                <p @click.prevent="nextPage(parent[0].id)" class="text-decoration-none text-black"  v-if="parent.length">&nbsp; {{ parent[0].title }} </p>
                <p v-if="self.length">&nbsp; / </p>
                <router-link class="text-decoration-none text-black" :to="`/Process/documentation/management/FolderAndFileMode/${self[0].id}`" v-if="self.length">&nbsp; {{ self[0].title }} </router-link>
              </div>
            </div>
          </center>
          <br>
          <div class="d-flex flex-wrap align-items-start justify-content-start">
           <div v-for="item in allCategories"  style="position:relative;">
             <Foldor @click.prevent="FolderSettingsMethod(item.id)" @dblclick="nextPage(item.id)"  :name="item.title"  />
             <div class="options" :id="`option_change_${item.id}`"
                  style="background-color: #fff; display: none; width: 8vw; height: 7vw; margin-right: 1vw; position:absolute; top: 5vw; right: 0; border-radius: 1vw">
               <p @click.prevent="edit(item.id)" style="cursor: pointer" class="border-bottom my-3 ">📝ویرایش</p>
               <p @click.prevent="deleteItem(item.id)" style="cursor: pointer">🗑️حذف</p>
             </div>
           </div>

            <div v-for="doc in allDocs"  @dblclick="downloadFile(doc.file)"  @click.prevent="FolderSettingsMethodDoc(doc.id)" style="position:relative;">
              <File  v-if="doc.file.endsWith('.txt')" :name="doc.name"  />
              <Word v-if="doc.file.endsWith('.doc')" :name="doc.name"/>
              <Pdf v-if="doc.file.endsWith('.pdf')" :name="doc.name"/>
              <Excel v-if="doc.file.endsWith('.xlsx')" :name="doc.name"/>
              <Image v-if="doc.file.endsWith('.jpg') || doc.file.endsWith('.png')" :name="doc.name"/>
              <div class="options" :id="`optionDoc_change_${doc.id}`"
                   style="background-color: #fff; display: none; width: 8vw; height: 2vw; margin-right: 1vw; position:absolute; top: 5vw; right: 0; border-radius: 1vw">
                <p @click.prevent="deleteItemDoc(doc.id)" style="cursor: pointer">🗑️حذف</p>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top bg-white" style="z-index: 999999999999999; width: auto;"
       v-show="rightContainer">
    <div>
      <div class="d-flex flex-nowrap no_print hide">
        <div class="col-lg-12">
          <div class="card     border-0">
            <div class="d-flex   flex-column" style=" width: 8vw;" :style="first.length && first[0]['type']==='4' ? 'width: 10vw' : ''">
              <p @click="addNewParent" v-if="first.length" style="cursor: pointer; " class=" addItem">
                <span>➕&nbsp;افزودن&nbsp;</span>
                <span v-if="first.length && first[0]['type']==='1'">طبقه</span>
                <span v-else-if="first.length && first[0]['type']==='2'">گروه</span>
                <span v-else-if="first.length && first[0]['type']==='3'">فرآیند</span>
                <span   v-else-if="first.length && first[0]['type']==='4'">زیر فرآیند</span>
              </p>
              <div class="border-bottom mb-3"></div>

              <p style="cursor: pointer;"
                 class="doc_item"
                  @click.prevent="addDocMethod"
                 v-if=" self.length && self[0]['type'] === '2' && self[0]['idcard_group']"
                  >📄افزودن مستند </p>
              <p @click.prevent="addDocMethod"
                 class="doc_item"

                 v-if=" self.length && self[0]['type'] === '3' && self[0]['idcard_process']"
                 style="cursor: pointer; ">افزودن مستند </p>
              <p @click.prevent="addDocMethod"
                 class="doc_item"

                 v-if=" self.length && self[0]['type'] === '4' && self[0]['idcard_sub_process']"
                 style="cursor: pointer; ">افزودن مستند </p>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ******************** -->
  <div dir="rtl" class="modal__error slide-top bg-white" style="z-index: 999999999999999; width: 24vw;"
       v-show="addNewParentModal || editModal || removeModal || removeModalDoc">
    <div>
      <div class="d-flex flex-nowrap no_print hide">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between ">
              <h2 v-if="addNewParentModal || editModal" style="font-size: 1.2vw !important;">
                <span>افزودن&nbsp;</span>
                <span v-if="first.length && first[0]['type']==='1'">طبقه</span>
                <span v-else-if="first.length && first[0]['type']==='2'">گروه</span>
                <span v-else-if="first.length && first[0]['type']==='3'">فرآیند</span>
                <span v-else-if="first.length && first[0]['type']==='4'">زیر فرآیند</span>
              </h2>
              <p v-if="addNewParentModal" @click.prevent="addNewParentModal=!addNewParentModal">❌</p>
              <p v-if="editModal" @click.prevent="editModal=!editModal">❌</p>
            </div>
            <div v-if="removeModal">
              <center>
                آیا می خواهید حدف کنید؟
              </center>
              <br>
              <div class="d-flex align-items-center  ">
                <button class="btn btn-primary btn-back mx-3" style="height: 2vw;" type="button"
                        @click="removeModal=!removeModal">
                  بازگشت
                </button>
                <button class="btn btn-primary   btn-submit-1" style="height: 2vw;" type="button"
                        @click="deleteItemForm(id)">
                  بله
                </button>

              </div>
            </div>
            <div v-if="removeModalDoc">
              <center>
                آیا می خواهید حدف کنید؟
              </center>
              <br>
              <div class="d-flex align-items-center  ">
                <button class="btn btn-primary btn-back mx-3" style="height: 2vw;" type="button"
                        @click="removeModalDoc=!removeModalDoc">
                  بازگشت
                </button>
                <button class="btn btn-primary   btn-submit-1" style="height: 2vw;" type="button"
                        @click="deleteItemFormDoc(id)">
                  بله
                </button>

              </div>
            </div>
            <form v-if="addNewParentModal || editModal" class="needs-validation" novalidate>
              <div class="d-flex justify-content-between" style="    width: 19vw;">
                <div class="col-lg-2 mb-3 ms-n-08" style="width: 9vw;">
                  <label class="form-label">عنوان </label>
                  <input class="form-control" v-model="nameCat" required>
                </div>
                <div class="col-lg-2 mb-3 ms-n-08" style="width: 9vw;">
                  <label class="form-label">عنوان انگلیسی</label>
                  <input class="form-control" v-model="nameCatEn" required>
                </div>
              </div>


              <button v-if="addNewParentModal" class="btn btn-primary   btn-submit-1" style="width: 20vw;" type="button"
                      @click="addCategory">
                افزودن
              </button>
              <button v-if="editModal" class="btn btn-primary   btn-submit-1" style="width: 20vw;" type="button"
                      @click="update(id)">
                ویرایش
              </button>


            </form>


          </div>
        </div>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top bg-white" style="z-index: 999999999999999; width: 33vw;"
       v-show="addDocModal">
    <div>
      <div class="d-flex flex-nowrap no_print hide">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between ">
              <form class="needs-validation mt-2 mb-3" novalidate>
                <div class="row flex-nowrap flex-column">
                 <div class="d-flex justify-content-evenly">
                   <div >
                     <label class="form-label">نام مدرک</label>
                     <input v-model="name_doc" class="form-control" type="text" name="" required>
                   </div>
                   <div >
                     <label class="form-label">کد مدرک</label>
                     <input v-model="code_doc" class="form-control" type="text" name="" required>
                   </div>
                 </div>
                 <div class="d-flex justify-content-evenly">
                   <div class="mx-2">
                     <label class="form-label">نوع مدرک</label>
                     <select style="width: 12vw;" v-model="type_doc" class="form-select" name="" required>
                       <option value="خط مشی">خط مشی</option>
                       <option value=" آیین نامه"> آیین نامه</option>
                       <option value="نظامنامه">نظامنامه</option>
                       <option value="روش اجرایی">روش اجرایی</option>
                       <option value="دستور العمل">دستور العمل</option>
                       <option value="مدارک طرح ریزی">مدارک طرح ریزی</option>
                       <option value="فرم ها">فرم ها</option>
                       <option value="برون سازمانی">برون سازمانی</option>
                     </select>
                   </div>
                   <div >
                     <label class="form-label ">محل بایگانی</label>
                     <input v-model="location_doc" class="form-control" type="text" name="" required>
                   </div>
                 </div>
                  <div class="d-flex justify-content-evenly">
                    <div style="width: 11vw;" >
                      <label class="form-label">مدت زمان بایگانی</label>
                      <input v-model="time_doc" class="form-control" type="text" name="" required>
                    </div>
                    <div  >
                      <label class="form-label"> فایل    </label>
                      <input   class="form-control" style="display:block; width: 12vw;" type="file" name="" id="file">
                    </div>
                  </div>
               <center>
                 <button

                     @click.prevent="addItem"
                     class="btn btn-primary btn-submit-1"
                     style="width: 3vw; height: 1.7vw; font-size: 1vw; padding: .5vw; text-align: center; margin-top: 1.5vw;  ">
                   ثبت
                 </button>
               </center>


                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ******************** -->
</template>
<script>

import {defineComponent} from "vue";
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Documents from "@/components/process_documentation_management/Document.vue";
import process from "@/components/process_documentation_management/proccess.vue";
import Organization from "@/components/process_documentation_management/Organization.vue";
import router from "@/router";
import File from "@/components/Docs/File.vue";
import Foldor from "@/components/Docs/Folder.vue";
import {useToast} from "vue-toastification";
import Word from "@/components/Docs/Word.vue";
import Pdf from "@/components/Docs/Pdf.vue";
import Excel from "@/components/Docs/Excel.vue";
import Image from "@/components/Docs/Image.vue";

const toast = useToast();

export default defineComponent({
  components: {Image, Excel, Pdf, Word, Foldor, File, Documents, Sidebar, Splash, process, Organization},
  data() {

    return {
      allItem: [
        {label: "خط مشی", value: "خط مشی"},
        {label: "آیین نامه", value: "آیین نامه"},
        {label: "نظامنامه", value: "نظامنامه"},
        {label: "روش اجرایی", value: "روش اجرایی"},
        {label: "دستور العمل", value: "دستور العمل"},
        {label: "مدارک طرح ریزی", value: "مدارک طرح ریزی"},
        {label: "فرم ها", value: "فرم ها"},
        {label: "برون سازمانی", value: "برون سازمانی"}
      ],
      allCategories: [],
      allDocs: [],
      categories: [],
      rightContainer: false,
      addDocModal: false,
      addNewParentModal: false,
      editModal: false,
      removeModal: false,
      removeModalDoc: false,
      nameCat: '',
      nameCatEn: '',
      id_route: this.$route['params']['id'],
      self: [],
      parent: [],
      first: [],
      cat: [],
      id: '',
      name_doc: '',
      code_doc: '',
      type_doc: '',
      location_doc: '',
      time_doc: '',
    }
  },
  methods: {
    deleteItem(id){
      this.id = id
      this.removeModal = true
    },
    deleteItemDoc(id){
      this.id = id
      this.removeModalDoc = true
    },
    addItem(){
      const fileInput = document.getElementById("file");

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('processes_id', this.self[0]['id'])
      formdata.append('name', this.name_doc)
      formdata.append('code', this.code_doc)
      formdata.append('type', this.type_doc)
      formdata.append('location', this.location_doc)
      formdata.append('time', this.time_doc)
      formdata.append('file', fileInput.files[0])


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/document_process/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              this.error=true

              this.errorMessage=response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return

            }
            this.name_doc=''
            this.code_doc=''
            this.type_doc=''
            this.location_doc=''
            this.time_doc=''
            fileInput.value=''
            this.allItemsCatById(this.self[0]['id'])
            this.rightContainerMethod()
            this.addDocModal= false

          })
          .catch();


    },
    edit(id){
      this.id = id
      this.editModal = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {



            this.nameCat = result.item.title
            this.nameCatEn = result.item.title_en

          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.nameCat.length) {
        formdata.append('title', this.nameCat)

      }
      if (this.nameCatEn.length) {
        formdata.append('title_en', this.nameCatEn)

      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              return
            }
            this.nameCat =  ''
            this.nameCatEn = ''
            this.id = ''
            this.editModal = false

            this.allItemsCat()
            this.removeAll()


          })
          .catch();
    },
    removeAll() {
      document.querySelectorAll('.options').forEach((ele) => ele.classList.remove('d-block'))

    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              return
            }
            this.nameCat =  ''
            this.nameCatEn = ''
            this.id = ''
            this.removeModal = false

            this.allItemsCat()
            this.removeAll()



          })
          .catch();

    }, deleteItemFormDoc(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/document_process/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              return
            }
            this.nameCat =  ''
            this.nameCatEn = ''
            this.id = ''
            this.removeModalDoc = false

            this.allItemsCatById(this.self[0]['id'])
            this.removeAll()



          })
          .catch();

    },
    addNewParent() {

      this.addNewParentModal = true
    },
    addDocMethod() {
      this.addDocModal = true
    },
    FolderSettingsMethod(id) {


      const div = document.querySelector(`#option_change_${id}`)
      if (div.classList.contains('d-block')) {
        div.classList.remove('d-block')

      } else {
        document.querySelectorAll('.options').forEach((ele) => ele.classList.remove('d-block'))
        div.classList.add('d-block')
      }


    },FolderSettingsMethodDoc(id) {


      const div = document.querySelector(`#optionDoc_change_${id}`)
      if (div.classList.contains('d-block')) {
        div.classList.remove('d-block')

      } else {
        document.querySelectorAll('.options').forEach((ele) => ele.classList.remove('d-block'))
        div.classList.add('d-block')
      }


    },
    downloadFile(file) {
      const fileUrl = `${file}`;
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank'; // این بخش باعث می‌شود لینک در یک صفحه جدید باز شود
      link.download = file; // این بخش باعث می‌شود فایل به نام موردنظر دانلود شود
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // پس از کلیک، لینک را از بدنه حذف می‌کنیم تا پاک شود
    },
    nextPage(id) {

      router.push(`/Process/documentation/management/FolderAndFileMode/${id}`)
      this.allItemsCatById(id)


    },
    addCategory() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.nameCat);
      formdata.append('title_en', this.nameCatEn);
      formdata.append('levelSub', this.first[0]['type']);


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/processes/store_parent/${this.self[0]['id']}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              return
            }
            this.allCategories.length = 0
            this.allItemsCatById(this.self[0]['id'])
            this.rightContainerMethod()
            this.nameCat = ''
            this.nameCatEn = ''
            this.rightContainer = !this.rightContainer
            this.addNewParentModal = !this.addNewParentModal
            toast.success('دسته بندی با موفقیت ایجاد شد!')
            this.rightContainerMethod()


          })
          .catch();
    },
    rightContainerMethod() {

      this.rightContainer = !this.rightContainer
    },
    allItemsCat() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.allCategories.length = 0
            this.allDocs.length = 0
            this.self.length = 0
            this.first.length = 0
            this.parent.length = 0
            this.cat.length = 0
            if (response.all) {
              response.all.forEach((ele) => {
                this.allCategories.push(ele)
              })
            }
            if (response.docs) {
              response.docs.forEach((ele) => {
                this.allDocs.push(ele)
              })
            }
            if (response.self) {
              this.self.push(response.self)

            }
            if (response.first) {
              this.first.push(response.first)

            }   if (response.parent) {
              this.parent.push(response.parent)

            }  if (response.cat) {
              this.cat.push(response.cat)

            }


          })
          .catch();
    },
    allItemsCatById(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all_by_id/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.allCategories.length = 0
            this.allDocs.length = 0
            this.self.length = 0
            this.first.length = 0
            this.parent.length = 0
            if (response.all) {
              response.all.forEach((ele) => {
                this.allCategories.push(ele)
              })
            }
            if (response.docs) {
              response.docs.forEach((ele) => {
                this.allDocs.push(ele)
              })
            }

            if (response.self) {
              this.self.push(response.self)

            }
            if (response.first) {
              this.first.push(response.first)

            }    if (response.parent) {
              this.parent.push(response.parent)

            } if (response.cat) {
              this.cat.push(response.cat)

            }


          })
          .catch();
    },


    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
      }

    }
  },
  mounted() {
    this.checkIsMother()
    this.allItemsCat()
  },

})
</script>
<style lang="scss" scoped>
.changes {
  background-color: #AFAFAF;
  height: 2vw;
  display: flex;
  width: 18vw;
  border-radius: 1vw;
  justify-content: space-between;
  padding: 1vw;

  & > a {
    color: #000;
    text-decoration: none;
    display: block;
    transform: translateY(-1vw);


  }

  & p {
    width: 8vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    border-radius: 1vw;
    transform: translateY(-1vw) translateX(-1vw);
    display: grid;
    place-items: center;

  }
}

.root {
  background-color: #fff;
  width: 20vw;
  border-radius: 0 0 1vw 1vw;
  display: block;
  text-decoration: none;
  color: #000;
  transform: translateY(-1vw);
}
.doc_item{
  text-align: right;
  transition: background-color ease 500ms;

  &:hover{
    background-color: #eee;
    width: 100%;
  }
}
.addItem{
  text-align: right;
transition: background-color ease 500ms;
  &:hover{
    background-color: #eee;
    width: 100%;
  }

}
</style>